import { render, staticRenderFns } from "./stock-deal.vue?vue&type=template&id=c946a4b0"
import script from "./stock-deal.vue?vue&type=script&lang=js"
export * from "./stock-deal.vue?vue&type=script&lang=js"
import style0 from "./stock-deal.vue?vue&type=style&index=0&id=c946a4b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports